import type { CmsColor } from "@/lib/cms/cms-theme.constants";
import { ShellThemeFields, type ShellThemeValues } from "./ShellThemeFields";

export type HeaderShellThemeValues = ShellThemeValues & {
  buttonColorId: string | null;
};

type Props = {
  colors: CmsColor[];
  values: HeaderShellThemeValues;
  onChange: (values: HeaderShellThemeValues) => void;
  onColorsChange?: (colors: CmsColor[]) => void;
};

export function HeaderShellThemeFields({
  colors,
  values,
  onChange,
  onColorsChange,
}: Props) {
  return (
    <div className="grid gap-6">
      <ShellThemeFields
        colors={colors}
        values={values}
        onColorsChange={onColorsChange}
        onChange={(shell) => onChange({ ...values, ...shell })}
      />
    </div>
  );
}
